import { FC } from "react";

import { Button, Typography } from "@/shared/ui";
import { useUIStore } from "@/stores";

import { useDeleteAccount } from "../../hooks";

import styles from "./delete-account-confirmation.module.scss";

const DeleteAccountConfirmation: FC = ({}) => {
  const { mutate: deleteAccount } = useDeleteAccount();
  const closeModal = useUIStore((state) => state.actions.modal.closeModal);

  return (
    <div className={styles.container}>
      <Typography semi variant="body" align="center" color="white" className={styles.title}>
        Delete Account
      </Typography>

      <Typography variant="footnote" align="center" className={styles.description}>
        Are you sure you want to delete your account? This action is permanent and will erase all your data, including
        your profile, matches, messages, and activity history
      </Typography>

      <div className={styles.controlButtons}>
        <Button fullWidth variant="primary" className={styles.negative} onClick={closeModal}>
          Cancel
        </Button>
        <Button fullWidth variant="secondary" onClick={() => deleteAccount()}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export { DeleteAccountConfirmation };
